import { getStorage, setStorage, removeStorage  } from '@/libs/storage';
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: getStorage('user_token'),
    config: [],
    user_info: JSON.parse(getStorage('user_info')) ?? null,
    path_name: '',
    // 网页版统一使用深色主题，不再提供模式切换。
    page_mode: true,
  },
  getters: {
    token: state => state.token,
    config: state => state.config,
    user_info: state => state.user_info,
    path_name: state => state.path_name,
    page_mode: state => state.page_mode,
  },
  mutations: {
    // 设置token
    setToken(state, value){
        state.token = value;
        setStorage('user_token', value);
    },
    // 设置配置
    setConfig(state, value){
        state.config = value;
    },
    // 设置会员信息
    setUserInfo(state, value){
        let obj = JSON.stringify(value) ?? '';
        state.user_info = value;
        setStorage('user_info', obj);
    },
    // 设置path
    setPath(state, value){
        state.path_name = value;
    },
  },
  actions: {
    // 登录
    login({ commit }, data){
        return new Promise((resolve, reject) => {
            if(!data || !data.token){
                return reject(new Error('登录信息缺少 token'));
            }
            commit('setToken', 'Bearer ' + data.token);
            commit('setUserInfo', data.user_info);
            return resolve();
        })
    },
    // 退出登录
    loginOut({ commit }, data){
        return new Promise(resolve => {
            commit('setToken', '');
            commit('setUserInfo', null);
            removeStorage('user_token');
            removeStorage('user_info');
            return resolve();
        })
    }
  },
  modules: {
  }
})
